module.exports = __webpack_public_path__ + "static/media/bell-hand1.b73cb478.aac";